import React, { Component } from 'react'
import Headshot from '../images/headshot.webp'

export default class About extends Component {
  render() {
    return (
      <section className="about" id='about'>
        <div className="container">
          <img src={ Headshot } alt='Reggie Hightower' />
          <h2>Erie, PA Fitness Done Right!</h2>
          <p>
              Motivated and exuberant fitness instructor with experience in versatile fitness settings. Passionate for developing fitness programs for clients and helping them transform their lives through the power of exercise and nutrition. Skilled in strength training, weight loss, SAQ training and boxing fitness.
          </p>
        </div>
      </section>
    )
  }
}
